import { render, staticRenderFns } from "./ClientsEvents_DELETE.vue?vue&type=template&id=435b9914&scoped=true"
import script from "./ClientsEvents_DELETE.vue?vue&type=script&lang=js"
export * from "./ClientsEvents_DELETE.vue?vue&type=script&lang=js"
import style0 from "./ClientsEvents_DELETE.vue?vue&type=style&index=0&id=435b9914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b9914",
  null
  
)

export default component.exports